export const setProtoTasksDate = ({ date }) => state => {
  return {
    ...state,
    scheduling: {
      ...state.scheduling,
      date,
    },
  };
};
